import React from 'react';
import { FormGroup } from 'components/common/Forms';
import { compose } from 'recompose';
import { Control } from 'react-redux-form';

export const SLA = ({ readOnly }) => (
  <FormGroup disabled={readOnly}>
    <Control.textarea updateOn="blur" model=".sla" />
  </FormGroup>
);

const enhance = compose();

export default enhance(SLA);



// WEBPACK FOOTER //
// ./src/pages/Installers/SLA.jsx